import React from 'react'

class ErrorBoundary extends React.Component {
    constructor (props) {
        super(props)
        this.state = { hasError: false, error: null, errorInfo: null }
    }

    static getDerivedStateFromError (error) {
        return { hasError: true, error }
    }

    componentDidCatch (error, errorInfo) {
    // Log to console or send to server
        console.error('ErrorBoundary caught:', error, errorInfo)
        this.setState({ error, errorInfo })
    }

    handleRetry = () => {
        this.setState({ hasError: false, error: null, errorInfo: null })
    }

    render () {
        if (this.state.hasError) {
            return (
                <div
                    style={{
                        height: '95%',
                        padding: '20px',
                        color: '#b00020',
                        background: 'hsl(var(--card))',
                        borderRadius: '8px',
                        margin: '20px'
                        // border: '1px solid #ffcccc'
                    }}
                >
                    <div className="h-full bg-gray-100 flex flex-col items-center justify-center p-4">
                        <div className="max-w-md w-full bg-white shadow-lg rounded-lg p-6 text-center">
                            <svg
                                className="mx-auto mb-4 w-32 h-32 text-red-500"
                                fill="none"
                                stroke="currentColor"
                                viewBox="0 0 24 24"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <path
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    strokeWidth="2"
                                    d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                                />
                            </svg>
                            <h1 className="text-2xl font-bold text-gray-800 mb-2">Something Went Wrong</h1>
                            <p className="text-gray-600 mb-4">
              Our team is actively investigating the issue. We apologize for the inconvenience and appreciate your patience while we get things back on track.
                            </p>
                            <div className="flex justify-center items-center space-x-4">
                                <button
                                    onClick={this.handleRetry}
                                    style={{
                                        marginTop: '15px',
                                        padding: '8px 16px',
                                        background: 'hsl(var(--primary))',
                                        color: 'white',
                                        border: 'none',
                                        borderRadius: '4px',
                                        cursor: 'pointer'
                                    }}
                                >
             Try Again
                                </button>
                                {/* <div clas>

                                    <a
                                        href="/support"
                                        className="bg-gray-200 text-gray-800 px-4 py-2 rounded hover:bg-gray-300 transition"
                                    >
                Contact Support
                                    </a>
                                </div> */}
                            </div>
                        </div>
                        {/* <div className="mt-6 text-gray-500 text-sm">
                            <p>Reference ID: {Math.random().toString(36).substring(2, 10).toUpperCase()}</p>
                        </div> */}
                    </div>

                    {/* Error message */}
                    {/* <pre style={{ whiteSpace: 'pre-wrap', color: 'black' }}>
                        {this.state.error?.toString()}
                    </pre> */}

                    {/* Component stack with file + line info */}
                    {/* {this.state.errorInfo && (
                        <details
                            style={{
                                marginTop: '10px',
                                padding: '10px',
                                background: '#f8f8f8',
                                borderRadius: '6px',
                                maxHeight: '200px',
                                overflow: 'auto',
                                fontSize: '13px'
                            }}
                            open
                        >
                            <summary>Stack trace</summary>
                            <pre style={{ whiteSpace: 'pre-wrap' }}>
                                {this.state.errorInfo.componentStack}
                            </pre>
                        </details>
                    )} */}
                </div>
            )
        }

        return this.props.children
    }
}

export default ErrorBoundary
